<template>
    <experimental-plans-component  
        :activeExperimentalPlans="activeExperimentalPlans" 
        :archivedExperimentalPlans="archivedExperimentalPlans" 
        @viewExperimentalPlan="handleViewExperimentalPlan" 
        @editExperimentalPlan="handleEditExperimentalPlan" 
        @experimentalDatasets="handleExperimentalDatasets" 
        @duplicatePlan="handleDuplicatePlan"
        @archiveExperimentalPlan="handleArchivedExperimentalPlan"
        @completeExperimentalPlan="handleCompleteExperimentalPlan">
    </experimental-plans-component>    
</template>


<script>
import ExperimentalPlansComponent from '@/components/plan/ExperimentalPlansComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "ExperimentalPlans",
    components: { ExperimentalPlansComponent},
    computed: {
        ...mapGetters([
            'base_url', 'auth_header'
        ]),
    },
    data: function() {
        return {
            component_url: 'experiments/plans',
            activeExperimentalPlans: [],
            archivedExperimentalPlans: []
        }
    },
    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_EXP_PLAN_ID'
        ]),
        setBreadcrumb: function(){
            console.log("sett explans rout: ", this.$route.meta.breadcrumb)
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        getActiveExperimentalPlans: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=False`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeExperimentalPlans = response.data;
                    console.log("Active ExperimentalPlans json: ")
                    console.log(this.activeExperimentalPlans)
                })
                .catch(error => {
                    console.log("Something went wrong getting the Experimental Plans :(", error);
                });
        },
        getArchivedExperimentalPlans: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=True`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.archivedExperimentalPlans = response.data;
                    console.log("Archived ExperimentalPlans json: ")
                    console.log(this.archivedExperimentalPlans)
                })
                .catch(error => {
                    console.log("Something went wrong getting the Experimental Plans :(", error);
                });
        },
        handleCompleteExperimentalPlan: function(currentPlan) {
            axios
                .patch(`${this.base_url}${this.component_url}/${currentPlan.id}/`,
                    {status: "COMPLETED"},
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Experimental Plan Successfully Completed:", currentPlan);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan Successfully Completed`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveExperimentalPlans();
                    this.getArchivedExperimentalPlans();
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan was not successfully Completed`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Experimental Plan was not successfully Completed: ", error.response.data);
                    this.getActiveExperimentalPlans();
                    this.getArchivedExperimentalPlans();
                });
        },
        handleArchivedExperimentalPlan: function(archivedExperimentalPlan){
            axios
                .patch(`${this.base_url}${this.component_url}/${archivedExperimentalPlan.id}/archive/`,
                    {},
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Experimental Plan Successfully Archived:", archivedExperimentalPlan);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan Successfully Archived`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.$router.push({ name: "ExperimentalPlans", params: {  } });
                    this.getActiveExperimentalPlans();
                    this.getArchivedExperimentalPlans();
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan was not successfully Archived`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    // this.$router.push({ name: "EditExperimentalPlan", params: { id: editedExperimentalPlan.id } });
                    console.log("Experimental Plan was not successfully Edited: ", error.response.data);
                    this.getActiveExperimentalPlans();
                    this.getArchivedExperimentalPlans();
                });
        },
        handleViewExperimentalPlan: function(currentExperimentalPlan) {
            console.log("handleViewExperimentalPlan: currExperimentalPlan is ", currentExperimentalPlan.name)
            this.$router.push({ name: "ViewExperimentalPlan", params: { id: currentExperimentalPlan.id } });
            // this.$root.$emit('viewPlan', currentExperimentalPlan);
        },
        handleEditExperimentalPlan: function(currentExperimentalPlan) {
            console.log("handleEditExperimentalPlan: currExperimentalPlan is ", currentExperimentalPlan.name)
            this.$router.push({ name: "EditExperimentalPlan", params: { id: currentExperimentalPlan.id } });
        },
        handleExperimentalDatasets: function(currentExperimentalPlan) {            
            console.log("handleExperimentalDatasets: currentExperimentalPlan is ", currentExperimentalPlan.name)
            this.setExpPlanId(currentExperimentalPlan)
            this.$router.push({ name: "ViewExperimentalDatasetsByPlan", params: { experimentalPlan: currentExperimentalPlan } });
        },
        setExpPlanId: function(currentExperimentalPlan){
            this.CHANGE_EXP_PLAN_ID(currentExperimentalPlan.id)
        },
        handleDuplicatePlan: function(currentPlan) {        
            delete currentPlan.id
            delete currentPlan.archived
            delete currentPlan.archivation_date
            delete currentPlan.status
            // console.log("handleDuplicatePlan: currPlan is ", currentPlan)
            
            axios
                .post(
                    this.base_url + this.component_url,
                    currentPlan,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(() => {
                    console.log("Experimental Plan Successfully Duplicated!");
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan Successfully Duplicated!`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveExperimentalPlans()
                    this.getArchivedExperimentalPlans()
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan was not successfully Duplicated!`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Experimental Plan was not successfully Duplicated!", error.response.data);
                });
        }
    },
    mounted: function(){
        this.setBreadcrumb()
        this.getActiveExperimentalPlans();
        this.getArchivedExperimentalPlans();
    }
}
</script>
